import {
    ROUTES_CREATE_SESSION,
    ROUTES_CLUB_MEMBERS,
    ROUTES_HOME,
    ROUTES_PROFILE_OVERVIEW,
    ROUTES_SESSION_OVERVIEW,
    ROUTES_SETTINGS_ACCOUNT,
    ROUTES_SETTINGS_BILLING,
    ROUTES_SETTINGS_INTEGRATIONS,
    ROUTES_SETTINGS_MY_CLUBS,
    ROUTES_SQUADS
} from '@/constants/routes';

export function notificationsRoute(type, modelName, id) {
    if (
        type === 'athlete-entered-data' ||
        type === 'coach-entered-data' ||
        type === 'athlete-invitation-to-session' ||
        type === 'coach-include-to-session' ||
        type === 'crews-publish-notification' ||
        type === 'crews-update-notification' ||
        type === 'crews-publish-reminder' ||
        type === 'crews-athlete-become-ill-or-injured' ||
        type === 'athlete-changed-attending' ||
        type === 'athlete-changed-health-status' ||
        type === 'session-view-permission-notifications'
    ) {
        return {
            name: ROUTES_SESSION_OVERVIEW,
            params: { sessionId: id }
        };
    }

    if (
        type === 'athlete_accepted_rejected_club_invitation' ||
        type === 'new-user-join-request' ||
        type === 'new-athlete-completed-registration' ||
        type === 'user-left-club'
    ) {
        return { name: ROUTES_CLUB_MEMBERS };
    }

    if (
        type === 'subscription_renewal_reminder_15_days_before' ||
        type === 'subscription_renewal_reminder_30_days_before'
    ) {
        return { name: ROUTES_SETTINGS_BILLING };
    }

    if (type === 'wall-comment-notification') {
        if (modelName === 'event') {
            return {
                name: ROUTES_SESSION_OVERVIEW,
                params: { sessionId: id }
            };
        }

        if (modelName === 'club') {
            return { name: ROUTES_SQUADS };
        }

        if (modelName === 'squad') {
            return {
                name: ROUTES_SQUADS,
                params: { squadId: id }
            };
        }

        if (modelName === 'profile') {
            return {
                name: ROUTES_PROFILE_OVERVIEW,
                params: { id: id }
            };
        }
    }

    if (type === 'custom-notification') {
        if (modelName === 'settings-account') {
            return { name: ROUTES_SETTINGS_ACCOUNT };
        }

        if (modelName === 'settings-integrations') {
            return { name: ROUTES_SETTINGS_INTEGRATIONS };
        }

        if (modelName === 'settings-my-clubs') {
            return { name: ROUTES_SETTINGS_MY_CLUBS };
        }

        if (modelName === 'create-session') {
            return { name: ROUTES_CREATE_SESSION };
        }
    }

    return { name: ROUTES_HOME };
}
